import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b860010e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "evaluation_list_view" }
const _hoisted_2 = { class: "evaluation_list" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "evaluation_list_item" }
const _hoisted_5 = { class: "item_title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space_line" }, null, -1))
const _hoisted_7 = { class: "evaluation_info" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "topic" }
const _hoisted_11 = { class: "topic_bg" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "exit_tips" }, "退出", -1))
const _hoisted_14 = { class: "topic_content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "topic_tips" }, "请选择", -1))
const _hoisted_16 = { class: "topic_title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space_line" }, null, -1))
const _hoisted_18 = { class: "answer_list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "submit_tips" }, "提交", -1))
const _hoisted_21 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_dialog, {
      show: _ctx.show && _ctx.evaluationList.length > 0 && _ctx.evaluationStatus == 1,
      "show-confirm-button": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close_btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeBtnClick && _ctx.closeBtnClick(...args)))
          }, [
            _createElementVNode("img", {
              src: require('../assets/image/close_black_icon.svg')
            }, null, 8, _hoisted_3)
          ]),
          _createVNode(_component_van_list, { style: {"overflow-y":"scroll"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evaluationList, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1),
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", {
                          class: "desc",
                          innerHTML: item.desc
                        }, null, 8, _hoisted_8),
                        _createElementVNode("button", {
                          class: _normalizeClass([
                    'action_button',
                    item.done ? 'reset_evaluation' : '',
                  ]),
                          onClick: ($event: any) => (_ctx.actionButtonClick(item.id))
                        }, _toDisplayString(item.done ? "重新测评" : "去测评"), 11, _hoisted_9)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_van_dialog, {
        show: _ctx.show && _ctx.evaluationStatus == 2,
        "show-confirm-button": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_van_button, {
              class: "exit_btn",
              onClick: _ctx.exitButtonClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('../assets/image/close_white_icon.svg'),
                  class: "exit_img"
                }, null, 8, _hoisted_12),
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentScaleQA.sort +
              "/" +
              _ctx.scaleQuestionList.length +
              ". " +
              _ctx.currentScaleQA.title), 1),
              _hoisted_17,
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentScaleQA.answer, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("button", {
                      class: _normalizeClass([
                    'answer_button',
                    _ctx.answerOption == item.option ? 'answer_button_seleted' : '',
                  ]),
                      onClick: ($event: any) => (_ctx.answerButtonClick(item.option))
                    }, _toDisplayString(item.option + "." + item.content), 11, _hoisted_19)
                  ]))
                }), 256))
              ]),
              (_ctx.currentScaleQA.sort == _ctx.scaleQuestionList.length)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    disabled: !_ctx.answerOption || _ctx.answerSubmiting,
                    class: "next_button submit_button",
                    onClick: _ctx.nextButtonClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_component_van_button, {
                    key: 1,
                    disabled: !_ctx.answerOption || _ctx.answerSubmiting,
                    class: "next_button",
                    onClick: _ctx.nextButtonClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('../assets/image/next_white_icon.svg'),
                        class: "next_icon"
                      }, null, 8, _hoisted_21)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}